module.exports = __webpack_public_path__ + "img/shg1.6d4e0c94.jpg";